import { defineComponent } from './base.js';
import { buildSearchResultButton, buildSearchResultsEmpty, type SearchResultConfig } from './legacyBuilders.js';

export interface SearchResultItem extends SearchResultConfig {
    label: string;
}

/**
 * `<viv-search-results>` — imperative container for a themed result dropdown.
 * Populate via `setResults(items)`; a `viv-select` event fires on row click.
 */
export class VivSearchResults extends HTMLElement {
    connectedCallback(): void {
        this.classList.add('vivDs-searchResults');
        if (!this.dataset.vivBound) {
            this.dataset.vivBound = '1';
            this.addEventListener('click', (event) => {
                const button = (event.target as HTMLElement).closest('.vivDs-searchResult');
                if (!button) return;
                this.dispatchEvent(new CustomEvent('viv-select', {
                    bubbles: true,
                    detail: { value: button.getAttribute('data-value') ?? button.textContent?.trim() ?? '' },
                }));
            });
        }
    }

    setResults(items: SearchResultItem[], emptyMessage = 'Keine Treffer.'): void {
        if (!items.length) {
            this.innerHTML = buildSearchResultsEmpty(emptyMessage);
            return;
        }
        this.innerHTML = items.map((item) => buildSearchResultButton({
            ...item,
            dataAttrName: item.dataAttrName ?? 'value',
            dataAttrValue: item.dataAttrValue ?? item.value ?? item.label,
        })).join('');
    }

    clear(): void {
        this.innerHTML = '';
    }
}

export function registerVivSearchResults(): void {
    defineComponent('viv-search-results', VivSearchResults);
}
